import { getEmailSendsLimitMultiplier } from 'pricing-pages-lib/utils/contactsUtils';
import { getBillingNameKey, getBundleProductForBundleTypeAndProductLevel, getBundleProductsForBundleType, getBundleType, getBundledProductLinesForSkuId, getBundledProductVersionsForSkuId, getBundledProductsForSkuId, getCoreSeatSkuForProductLevel, getCrmSuiteProductLevelForSkuIds, getCrmSuiteProductLevels, getCrmSuiteProductLinesForProductLevel, getCurrentProductVersion, getCurrentSkuIdForProduct, getCurrentSuiteSkuIdsForProductLevel, getHighestProductLevelFromSkuIds, getHighestProductLevelSkuIdsByProductLine, getIncludedCoreSeatsQuantityForProductVersion, getIncludedCoreSeatsQuantityForSuiteProductLevel, getIncludedSeatQuantityBySkuId, getIsCoreSeatSku, getIsPaidCoreSeatSku, getIsSalesOrServiceProOrEntSku, getIsSalesSeatQuantityPackSku, getIsSalesSeatSku, getIsServiceSeatQuantityPackSku, getIsServiceSeatSku, getLowestPaidProductLevel, getLowestPaidProductLevelFromList, getMaxProductVersionQuantity, getProduct, getProductForSkuId, getProductLevelForSkuId, getProductVersion, getQuantifiableSkusForProductLine, getQuantityPackForProductVersion, getSeatUnitNameForSkuId, getSkuIdForFreeProduct, getSkuIdIsATBSuiteBundle, getSkuIdIsAddonOrService, getSkuIdIsHub, getSkuIdIsInCrmSuite, getSkuIdIsOrHasHub, getSkuIdIsQuantityPack, getSkuIdsContainOnlyCRMSuite, hasAnySeatsSkuInProductData, hasAnyTBSkuInProductData, hasMisMatchedProductsAndPromotions, hasMismatchedGatingForSeats, isBundleListWithConsistentType, isCrmSuiteProductLevel, isMarketingContactsQuantityPack, isPaidSalesServiceSeat, isQuantifiableHub, isQuantityUpgrade, skuIdHasBundledProducts } from 'pricing-pages-lib/utils/productsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getUpgradeProduct } from 'pricing-pages-lib/utils/upgradeProductUtils';
import { getMerchCardsToShow } from 'pricing-pages-ui/constants/merchCards/MerchCardsToShow';
import { PRODUCT_HUBSPOT_FREE } from 'self-service-api/constants/ProductIds';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { skuMapSelector, transformState } from './SelectorUtils';
export const fetchProductsStatus = makeRequestStatusSelector(FetchProductsRequestTypes.REQUEST);

/**
 * @deprecated as part of TB, consider {@link quantityPackApiNameToProductIdSelector}
 */
export const parcelNameToProductIdSelector = ({
  abstractedProducts: {
    parcelNameToProductId
  }
}) => parcelNameToProductId;
export const quantityPackApiNameToProductIdSelector = ({
  abstractedProducts: {
    quantityPackApiNameToProductId
  }
}) => quantityPackApiNameToProductId;
export const quantityPackApiNameForProductIdSelector = (state, {
  productId
}) => {
  const quantityPackApiNameToProductId = quantityPackApiNameToProductIdSelector(state);
  if (!quantityPackApiNameToProductId) return null;
  for (const [quantityPackApiName, productApiNames] of Object.entries(quantityPackApiNameToProductId)) {
    if (Object.values(productApiNames).some(localProductId => localProductId === productId)) {
      return quantityPackApiName;
    }
  }
  return null;
};
export const productApiNameForProductIdSelector = (state, {
  productId
}) => {
  const quantityPackApiNameToProductId = quantityPackApiNameToProductIdSelector(state);
  if (!quantityPackApiNameToProductId) return null;
  for (const productApiNames of Object.values(quantityPackApiNameToProductId)) {
    for (const [productApiName, localProductId] of Object.entries(productApiNames)) {
      if (localProductId === productId) {
        return productApiName;
      }
    }
  }
  return null;
};
export const productIdForQuantityPackAndProductApiNameSelector = (state, {
  quantityPackApiName,
  productApiName
}) => {
  const quantityPackApiNameToProductId = quantityPackApiNameToProductIdSelector(state);
  if (!quantityPackApiNameToProductId) {
    return null;
  }
  const quantityPackApiNameObj = quantityPackApiNameToProductId[quantityPackApiName];
  if (quantityPackApiNameObj && quantityPackApiNameObj[productApiName]) {
    return quantityPackApiNameObj[productApiName];
  }
  return null;
};
export const skuSelector = (state, {
  skuId
}) => {
  const skuMap = skuMapSelector(state);
  return skuMap[skuId];
};
export const productSelector = createSelectorFromUtil(getProduct, transformState);
export const productVersionSelector = createSelectorFromUtil(getProductVersion, transformState);

/**
 * @description Before using this util, confirm that product data is present using hasPricingAndPurchasingSucceededSelector.
 */
export const productForSkuIdSelector = createSelectorFromUtil(getProductForSkuId, transformState);
export const currentSkuIdForProductSelector = createSelectorFromUtil(getCurrentSkuIdForProduct, transformState);
export const skuIdForFreeProductSelector = createSelectorFromUtil(getSkuIdForFreeProduct, transformState);
export const skuIdIsHubSelector = createSelectorFromUtil(getSkuIdIsHub, transformState);
export const crmSuiteProductLevelSelector = createSelectorFromUtil(getCrmSuiteProductLevelForSkuIds, transformState);
export const skuIdIsPartOfCrmSuiteSelector = createSelectorFromUtil(getSkuIdIsInCrmSuite, transformState);
export const skuIdsContainOnlyCrmSuite = createSelectorFromUtil(getSkuIdsContainOnlyCRMSuite, transformState);
export const billingNameKeySelector = createSelectorFromUtil(getBillingNameKey, transformState);
export const quantityPackForProductVersionSelector = createSelectorFromUtil(getQuantityPackForProductVersion, transformState);
export const includedCoreSeatsQuantityForProductVersionSelector = createSelectorFromUtil(getIncludedCoreSeatsQuantityForProductVersion, transformState);
export const includedCoreSeatsQuantityForSuiteProductLevelSelector = createSelectorFromUtil(getIncludedCoreSeatsQuantityForSuiteProductLevel, transformState);
export const skuIdIsAddonOrServiceSelector = createSelectorFromUtil(getSkuIdIsAddonOrService, transformState);
export const currentProductVersionSelector = createSelectorFromUtil(getCurrentProductVersion, transformState);
export const maxProductVersionQuantitySelector = createSelectorFromUtil(getMaxProductVersionQuantity, transformState);
export const emailSendsLimitMultiplierSelector = createSelectorFromUtil(getEmailSendsLimitMultiplier, transformState);
export const lowestPaidProductLevelSelector = createSelectorFromUtil(getLowestPaidProductLevel, transformState);
export const lowestPaidProductLevelFromListSelector = createSelectorFromUtil(getLowestPaidProductLevelFromList, transformState);
export const upgradeProductSelector = createSelectorFromUtil(getUpgradeProduct, transformState);
export const highlightedSkuIdsSelector = (state, {
  productLine,
  selectedTab,
  includeFree
}) => {
  const merchCardsToShow = getMerchCardsToShow({
    tab: selectedTab
  });
  const paidSkuIds = merchCardsToShow.map(productLevel => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  if (includeFree) {
    return [currentSkuIdForProductSelector(state, {
      productId: PRODUCT_HUBSPOT_FREE
    }), ...paidSkuIds];
  }
  return paidSkuIds;
};
export const allProductVersionsSelector = ({
  abstractedProducts: {
    productVersions
  }
}) => productVersions || {};

/**
 * Selects the product map in a format that is used in ui-addon-upgrades and self-service-api
 */
export const rawProductListSelector = ({
  abstractedProducts: {
    rawProductList
  }
}) => rawProductList;
export const skuIdIsQuantityPackSelector = createSelectorFromUtil(getSkuIdIsQuantityPack, transformState);
export const isSalesOrServiceProOrEntSkuSelector = createSelectorFromUtil(getIsSalesOrServiceProOrEntSku, transformState);
export const getQuantifiableSkusForProductLineSelector = createSelectorFromUtil(getQuantifiableSkusForProductLine, transformState);
export const highestProductLevelFromSkuIdsSelector = createSelectorFromUtil(getHighestProductLevelFromSkuIds, transformState);
export const isCoreSeatSkuSelector = createSelectorFromUtil(getIsCoreSeatSku, transformState);
export const isPaidCoreSeatSkuSelector = createSelectorFromUtil(getIsPaidCoreSeatSku, transformState);
export const coreSeatSkuForProductLevelSelector = createSelectorFromUtil(getCoreSeatSkuForProductLevel, transformState);
export const isQuantityUpgradeSelector = createSelectorFromUtil(isQuantityUpgrade, transformState);
export const highestProductLevelSkuIdsByProductLineSelector = createSelectorFromUtil(getHighestProductLevelSkuIdsByProductLine, transformState);
export const isQuantifiableHubSelector = createSelectorFromUtil(isQuantifiableHub, transformState);
export const isMarketingContactsQuantityPackSelector = createSelectorFromUtil(isMarketingContactsQuantityPack, transformState);
export const isCrmSuiteProductLevelSelector = createSelectorFromUtil(isCrmSuiteProductLevel, transformState);
export const crmSuiteProductLevelsSelector = createSelectorFromUtil(getCrmSuiteProductLevels, transformState);
export const crmSuiteProductLinesForProductLevelSelector = createSelectorFromUtil(getCrmSuiteProductLinesForProductLevel, transformState);
export const currentSuiteSkuIdsForProductLevelSelector = createSelectorFromUtil(getCurrentSuiteSkuIdsForProductLevel, transformState);
export const bundledProductsForSkuIdSelector = createSelectorFromUtil(getBundledProductsForSkuId, transformState);
export const bundledProductVersionsForSkuIdSelector = createSelectorFromUtil(getBundledProductVersionsForSkuId, transformState);
export const skuIdHasBundledProductsSelector = createSelectorFromUtil(skuIdHasBundledProducts, transformState);
export const bundledProductLinesForSkuIdSelector = createSelectorFromUtil(getBundledProductLinesForSkuId, transformState);
export const isPaidSalesServiceSeatSelector = createSelectorFromUtil(isPaidSalesServiceSeat, transformState);
export const hasAnyTBSkuInProductDataSelector = createSelectorFromUtil(hasAnyTBSkuInProductData, transformState);
export const hasAnySeatsSkuInProductDataSelector = createSelectorFromUtil(hasAnySeatsSkuInProductData, transformState);
export const hasMisMatchedProductsAndPromotionsSelector = createSelectorFromUtil(hasMisMatchedProductsAndPromotions, transformState);
export const hasMismatchedGatingForSeatsSelector = createSelectorFromUtil(hasMismatchedGatingForSeats, transformState);
export const getIsTBSkuSelector = createSelectorFromUtil(getSkuIdIsATBSuiteBundle, transformState);
export const skuIdIsOrHasHubSelector = createSelectorFromUtil(getSkuIdIsOrHasHub, transformState);
export const seatUnitNameForSkuIdSelector = createSelectorFromUtil(getSeatUnitNameForSkuId, transformState);
export const skuIdIsSalesSeatSelector = createSelectorFromUtil(getIsSalesSeatSku, transformState);
export const skuIdIsSalesSeatQuantityPackSelector = createSelectorFromUtil(getIsSalesSeatQuantityPackSku, transformState);
export const skuIdIsServiceSeatSelector = createSelectorFromUtil(getIsServiceSeatSku, transformState);
export const skuIdIsServiceSeatQuantityPackSelector = createSelectorFromUtil(getIsServiceSeatQuantityPackSku, transformState);
export const productLevelForSkuIdSelector = createSelectorFromUtil(getProductLevelForSkuId, transformState);
export const isBundleListWithConsistentTypeSelector = createSelectorFromUtil(isBundleListWithConsistentType, transformState);
export const bundleProductsForBundleTypeSelector = createSelectorFromUtil(getBundleProductsForBundleType, transformState);
export const bundleProductForBundleTypeAndProductLevelSelector = createSelectorFromUtil(getBundleProductForBundleTypeAndProductLevel, transformState);
export const getBundleTypeSelector = createSelectorFromUtil(getBundleType, transformState);
export const includedSeatQuantityBySkuIdSelector = createSelectorFromUtil(getIncludedSeatQuantityBySkuId, transformState);